"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "icon"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.7372 2.07129L21.7031 1.81247C21.5617 1.28455 21.0226 0.967991 20.4926 1.10166L20.7372 2.07129ZM15.6566 2.32143C15.1211 2.4565 14.7964 3.00011 14.9315 3.53562C15.0666 4.07114 15.6102 4.39576 16.1457 4.26069L15.6566 2.32143ZM21.0341 7.04295C21.177 7.57642 21.7254 7.893 22.2588 7.75006C22.7923 7.60712 23.1089 7.05878 22.9659 6.52531L21.0341 7.04295ZM3.11815 13.0072C2.56974 12.9419 2.07226 13.3336 2.007 13.882C1.94175 14.4304 2.33343 14.9279 2.88185 14.9932L3.11815 13.0072ZM20.9438 3.33067C21.1263 2.80942 20.8517 2.23889 20.3305 2.05636C19.8092 1.87383 19.2387 2.14842 19.0562 2.66967L20.9438 3.33067ZM17 15.0002C17 14.4479 16.5523 14.0002 16 14.0002C15.4477 14.0002 15 14.4479 15 15.0002H17ZM15 21.0002C15 21.5525 15.4477 22.0002 16 22.0002C16.5523 22.0002 17 21.5525 17 21.0002H15ZM9 18.0002C9 17.4479 8.55228 17.0002 8 17.0002C7.44772 17.0002 7 17.4479 7 18.0002H9ZM7 21.0002C7 21.5525 7.44772 22.0002 8 22.0002C8.55228 22.0002 9 21.5525 9 21.0002H7ZM13 17.0002C13 16.4479 12.5523 16.0002 12 16.0002C11.4477 16.0002 11 16.4479 11 17.0002H13ZM11 21.0002C11 21.5525 11.4477 22.0002 12 22.0002C12.5523 22.0002 13 21.5525 13 21.0002H11ZM5 19.0002C5 18.4479 4.55228 18.0002 4 18.0002C3.44772 18.0002 3 18.4479 3 19.0002H5ZM3 21.0002C3 21.5525 3.44772 22.0002 4 22.0002C4.55228 22.0002 5 21.5525 5 21.0002H3ZM21 11.0002C21 10.4479 20.5523 10.0002 20 10.0002C19.4477 10.0002 19 10.4479 19 11.0002H21ZM19 21.0002C19 21.5525 19.4477 22.0002 20 22.0002C20.5523 22.0002 21 21.5525 21 21.0002H19ZM20.4926 1.10166L15.6566 2.32143L16.1457 4.26069L20.9818 3.04092L20.4926 1.10166ZM19.7713 2.33011L21.0341 7.04295L22.9659 6.52531L21.7031 1.81247L19.7713 2.33011ZM2.88185 14.9932C4.76946 15.2178 8.36483 14.831 11.9245 13.1619C15.5175 11.4772 19.152 8.44749 20.9438 3.33067L19.0562 2.66967C17.4806 7.169 14.2988 9.83964 11.0755 11.3511C7.81885 12.8781 4.59789 13.1832 3.11815 13.0072L2.88185 14.9932ZM15 15.0002V21.0002H17V15.0002H15ZM7 18.0002V21.0002H9V18.0002H7ZM11 17.0002V21.0002H13V17.0002H11ZM3 19.0002V21.0002H5V19.0002H3ZM19 11.0002V21.0002H21V11.0002H19Z",
    fill: props.color
  }));
}
var _default = SvgComponent;
exports["default"] = _default;